"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormRow = exports.FormColumn = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2;

var FormColumn = _styledComponents["default"].div.withConfig({
  displayName: "Formstyles__FormColumn",
  componentId: "sc-2tjytq-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w-100 ph2 ph3-ns"]))));

exports.FormColumn = FormColumn;

var FormRow = _styledComponents["default"].div.withConfig({
  displayName: "Formstyles__FormRow",
  componentId: "sc-2tjytq-1"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["w-100 flex pb2"]))));

exports.FormRow = FormRow;